// unit to use for calculating collection sidebar spacing (in px)
export const SIDEBAR_SPACER = 18;
export const SIDEBAR_WIDTH = "340px";
export const ANALYTICS_CONTEXT = "Collection Landing";
